export function companyLabel(companyContext) {
  return (
    companyContext?.label ||
    companyContext?.short_name ||
    companyContext?.display_name ||
    companyContext?.name ||
    "Company"
  );
}

export function companyRoleLabels(companyContext) {
  const label = companyLabel(companyContext);
  return {
    projectManager: `${label} Project Manager`,
    supervisor: `${label} Supervisor`,
  };
}